import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Icon from 'components/system/Icon';
import colors from 'styles/colors';
import styles from './userHome.styles';

const QuickLinks = ({ navigate }) => {
  const links = [
    { label: 'Fastest Simulators and QPUs', path: '/docs#devices' },
    { label: 'Supports Cirq and Qiskit', path: '/docs#getting_started' },
    { label: 'Simulate up to 40 qubits with 3 lines of code', path: '/docs#getting_started' },
  ];
  return (
    <Box>
      {links.map((link, index) => (
        <Box
          key={link.path}
          sx={{ ...styles.links, marginTop: index > 0 ? '8px' : '0' }}
          onClick={() => navigate(link.path)}
        >
          <Typography sx={styles.linkText}>{link.label}</Typography>
          <Icon name="arrow_up_right" size={12} color={colors.text.primary} sx={{ marginLeft: '10px' }} />
        </Box>
      ))}
    </Box>
  );
};

export default QuickLinks;
